
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {CustomerMetricsList} from "../models/customerMetricsList";



@Injectable({ providedIn: 'root' })
export class CustomerMetricsService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    get(createdAt, createdAtTo, type: string) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/customer-metrics`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo,
            'type': type
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: CustomerMetricsList) => {
                return x;
            }));
    }
}
